// Validation + utilities for user forms.

/** Acepta solo letras (incluye acentos y ñ), espacios, apóstrofo y guion. */
const NAME_REGEX = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ' -]*$/;

export function isValidName(value) {
  return typeof value === "string" && value.trim().length >= 2 && NAME_REGEX.test(value);
}

/** Sanitiza el input eliminando caracteres que no sean letras/espacio/'/-. */
export function sanitizeName(value) {
  if (!value) return "";
  return value.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ' -]/g, "");
}

/** Verifica si un email tiene formato válido. */
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");
}

/**
 * Genera una contraseña segura de 8 caracteres garantizando:
 *  - al menos 1 mayúscula, 1 minúscula, 1 dígito, 1 símbolo.
 *  - sin caracteres ambiguos (0/O/1/l/I).
 */
export function generateSecurePassword(length = 8) {
  const UP = "ABCDEFGHJKMNPQRSTUVWXYZ";
  const LO = "abcdefghijkmnpqrstuvwxyz";
  const NU = "23456789";
  const SY = "!@#$%&*?";
  const ALL = UP + LO + NU + SY;
  const rnd = (set) => set[Math.floor(Math.random() * set.length)];
  // Garantiza un caracter de cada grupo
  let pwd = [rnd(UP), rnd(LO), rnd(NU), rnd(SY)];
  for (let i = pwd.length; i < length; i++) pwd.push(rnd(ALL));
  // Shuffle (Fisher-Yates)
  for (let i = pwd.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pwd[i], pwd[j]] = [pwd[j], pwd[i]];
  }
  return pwd.join("");
}

/** Acepta sólo dígitos, espacios, +, -, ( ) — útil para teléfono. */
export function sanitizePhone(value) {
  if (!value) return "";
  return value.replace(/[^0-9+\-() ]/g, "");
}

/** Verifica que un File sea una imagen aceptada. */
export const ACCEPTED_IMAGE_MIMES = ["image/png", "image/jpeg", "image/jpg", "image/webp", "image/gif"];
export function isAcceptedImage(file) {
  if (!file) return false;
  return ACCEPTED_IMAGE_MIMES.includes(file.type);
}
